'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createReactContext=require('create-react-context'),_createReactContext2=_interopRequireDefault(_createReactContext);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var FormContext=(0,_createReactContext2.default)();exports.default=FormContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vitalsource/vstui/context/FormContext.js
// module id = 168
// module chunks = 162